import React, { useMemo } from 'react';
import styles from './shoppingNav.module.scss.js';
import { Logo } from './Logo/index.js';
import { CategoryBar } from './CategoryBar/index.js';
import { SearchWrapper } from './SearchWrapper/index.js';
import { getTopLevelNavItems } from '../../utils/commerce/navigation.js';

/* eslint-disable camelcase */
// import * as categoryData from '../../constants/commerce/category';

const categoryData = require('../../constants/commerce/category');
function ShoppingNav(_ref) {
  let {
    setShowOverlay,
    showOverlay,
    tracking,
    edition = 'en-us',
    pageType = 'default',
    searchQuery = '',
    trackClientContentAction = () => {},
    attachClientImpressionHandler = () => {},
    useUnitTracking = () => {},
    useClickTracking = () => {},
    baseUrl = '/shopping',
    //for non-us editions
    baseParamsString = '',
    isPrimeDay = false
  } = _ref;
  const COMMERCE_CATEGORIES = categoryData[edition].COMMERCE_CATEGORIES;
  const topLevelNavItems = getTopLevelNavItems(COMMERCE_CATEGORIES);
  // set tracking options for anything in the header
  let trackingPos = 1;
  const isShowPrimeDay = isPrimeDay && pageType === 'default' && edition === 'en-us';
  const trackingLayer = useMemo(() => ({
    ...tracking,
    unit_name: 'shopping_header',
    unit_type: 'nav',
    position_in_unit: trackingPos++
  }), [tracking]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: `${styles.headerWrapper} ${isShowPrimeDay ? styles.primeDay : ''} ${pageType !== 'default' ? styles.headerCategoryWrapper : ''}`
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.headerContent
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.content
  }, /*#__PURE__*/React.createElement(Logo, {
    tracking: trackingLayer,
    pageType: pageType,
    useUnitTracking: useUnitTracking,
    baseUrl: baseUrl,
    baseParamsString: baseParamsString,
    isShowPrimeDay: isShowPrimeDay
  })), /*#__PURE__*/React.createElement(SearchWrapper, {
    searchQuery: searchQuery,
    tracking: trackingLayer,
    pageType: pageType,
    edition: edition,
    setShowOverlay: setShowOverlay,
    trackClientContentAction: trackClientContentAction,
    attachClientImpressionHandler: attachClientImpressionHandler,
    useUnitTracking: useUnitTracking,
    baseUrl: baseUrl,
    baseParamsString: baseParamsString
  }), /*#__PURE__*/React.createElement(CategoryBar, {
    edition: edition,
    tracking: trackingLayer,
    pageType: pageType,
    setShowOverlay: setShowOverlay,
    showOverlay: showOverlay,
    topLevelNavItems: topLevelNavItems,
    useUnitTracking: useUnitTracking,
    useClickTracking: useClickTracking,
    trackClientContentAction: trackClientContentAction,
    baseUrl: baseUrl
  }))));
}

export { ShoppingNav, ShoppingNav as default };
